module.exports = __webpack_public_path__ + "static/media/Virizion_gaussian2.858abb6f.png";